import Tone from 'tone'

export default [
	{
		id: 1,
		name: 'chimes',
		icon: './Punches/chimes.png',
		rowNum: 1,
		track: new Tone.Player({
			url: './Punches/Punches1.mp3',
			fadeIn: 0.1,
			fadeOut: 0.1
		}).toMaster()
	},
	{
		id: 2,
		name: 'clapping',
		icon: './Punches/clap.png',
		rowNum: 1,
		track: new Tone.Player({
			url: './Punches/Punches2Alt.mp3',
			fadeIn: 0.1,
			fadeOut: 0.1
		}).toMaster()
	},
	{
		id: 3,
		name: 'swing',
		icon: './Punches/swing.png',
		rowNum: 2,
		track: new Tone.Player({
			url: './Punches/Punches3.mp3',
			fadeIn: 0.1,
			fadeOut: 0.1
		}).toMaster()
	},
	{
		id: 4,
		name: 'crash',
		icon: './Punches/cymbal.png',
		rowNum: 2,
		track: new Tone.Player({
			url: './Punches/Punches4.mp3',
			fadeIn: 0.1,
			fadeOut: 0.1
		}).toMaster()
	}
]



// WEBPACK FOOTER //
// ./src/Punch/punchData.js